

export default {

    data() {
        return {
            visible: false,
            isReady: false,
        }
    },

    methods: {
        setVisible() {
            this.visible = true
            //this.$fetch()
            this.getData()
        },

    },

    computed: {

    }

}

